import React from "react";
import logoUrl from "../assets/goldenelia-full.png";

/**
 * Golden Elia compact brand mark — the COMPLETE logo (tree + wordmark + branches)
 * shrunk for navbar use. Identical to the hero logo, just smaller — no half-cut
 * branches, no duplicated text labels.
 */
export const OliveLogo = ({ size = 36, className = "" }) => {
  return (
    <img
      data-testid="goldenelia-logo"
      src={logoUrl}
      alt="Golden Elia — Greek Treasure"
      className={className}
      draggable={false}
      style={{
        display: "block",
        width: "auto",
        height: size,
        objectFit: "contain",
        flexShrink: 0,
        imageRendering: "auto",
      }}
    />
  );
};

export default OliveLogo;
